import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinimizeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 14H10M10 14V20M10 14L3 21M20 10H14M14 10V4M14 10L21 3",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		stroke: "currentColor"
	})
});
export default SvgMinimizeIcon;
